'use strict';
var DesktopSearch, SearchBarView, placeholderState, whichKeyAlias,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

whichKeyAlias = require('../../../../../../src/frontend/helper/search/common/m_keypress').whichKeyAlias;

placeholderState = require('../../../../../../src/frontend/helper/search/helper/m_common').placeholderState;

SearchBarView = require('../../../../../../src/frontend/search/search');

module.exports = DesktopSearch = (function(superClass) {
  extend(DesktopSearch, superClass);

  function DesktopSearch(opts) {
    if (opts == null) {
      opts = {};
    }
    this.$body = $(document.body);
    Object.assign(opts, {
      env: 'desktop',
      elements: {
        form: 'form#ls-search-form',
        search: '#ls-search',
        location: '#ls-location',
        resultList: '#ls-search-results',
        submitBtn: '#ls-header-search-button'
      },
      options: {
        enableRecentSearches: true,
        setExperiments: this.setExperiments.bind(this)
      }
    });
    Groupon.LS.experiments['enableRecentLocations'] = false;
    this.useLocationPlacesAPI = false;
    this.$primaryNavTabs = $('.primary-nav-tab');
    this.init(opts);
  }

  DesktopSearch.prototype.bind = function() {
    this.$inputs.on({
      keydown: (function(_this) {
        return function(e) {
          var $match, $selectedItem;
          switch (whichKeyAlias(e)) {
            case 'Enter':
              if (e.currentTarget.name === 'location') {
                e.preventDefault();
                if (($match = _this.typeahead.$container.find('.typeahead-match-highlight')).length) {
                  $match.trigger('click');
                } else {
                  _this.typeahead.hide();
                  _this.$form.trigger('submit');
                }
              }
              break;
            case 'Tab':
              $selectedItem = _this.$resultList.find('.typeahead-match');
              if ($selectedItem.length) {
                e.preventDefault();
                _this.selectAndTab($selectedItem, e.shiftKey);
              } else {
                _this.typeahead.hide();
              }
              break;
            case 'ArrowDown':
              _this.$resultList.find('a').eq(0).focus();
              _this.$resultList.find('.typeahead-match').removeClass('typeahead-match-highlight');
              e.preventDefault();
          }
        };
      })(this),
      focusin: (function(_this) {
        return function(e) {
          var $parent;
          _this.$body.eventPause('pause');
          if (!($parent = $(e.currentTarget).parent()).hasClass('active-search')) {
            _this.$form.find('label, div').removeClass('active-search');
            return $parent.addClass('active-search');
          }
        };
      })(this),
      focusout: (function(_this) {
        return function(e) {
          var $locLabel, $searchLabel, $this;
          _this.$body.eventPause('active');
          $this = $(e.currentTarget);
          $this.parent().removeClass('active-search');
          placeholderState.toggle($this);
          if (!$('html.ui-v3').length) {
            $searchLabel = _this.$search.parent();
            $locLabel = _this.$location.parent();
            if (!$searchLabel.is('.active-search') && !$locLabel.is('.active-search')) {
              return $searchLabel.addClass('active-search');
            }
          }
        };
      })(this)
    });
    this.$resultList.on('keydown', 'a', (function(_this) {
      return function(e) {
        var $el, $results, $widget;
        e.preventDefault();
        $widget = _this.$resultList;
        $results = $widget.find('a');
        switch (whichKeyAlias(e)) {
          case 'Enter':
            $el = $(e.currentTarget);
            if ($el.hasClass('current-location')) {
              return $el.trigger('click');
            } else {
              return _this.selectAndFill($el);
            }
            break;
          case 'ArrowUp':
            return $results.eq($results.index(e.currentTarget) - 1).focus();
          case 'ArrowDown':
            return $results.eq($results.index(e.currentTarget) + 1).focus();
          case 'Tab':
            return _this.selectAndTab($(e.currentTarget), e.shiftKey);
          default:
            return _this.$resultList.prev('input').focus();
        }
      };
    })(this));

    /*
     * Global events
     */
    return this.$body.on('click', (function(_this) {
      return function() {
        return _this.typeahead.hide();
      };
    })(this));
  };

  DesktopSearch.prototype.setExperiments = function() {
    this.$location.one('focus', (function(_this) {
      return function(e) {
        return typeof Finch !== "undefined" && Finch !== null ? Finch.experiment('LS-3153-RecentLocationsDesktop', {
          Control: function() {},
          RecentLocations: function() {
            Groupon.LS.experiments['enableRecentLocations'] = true;
            return _this.typeahead.enableRecentLocations(e);
          }
        }) : void 0;
      };
    })(this));
    return this.$location.on('input.enablePlaceApi', (function(_this) {
      return function(e) {
        Finch.experiment('LS-3106-AddressAutocomplete', {
          Control: function() {},
          Treatment: function() {
            _this.useLocationPlacesAPI = true;
            return _this.typeahead.enableLocationPlacesAPI(e);
          }
        });
        return _this.$location.off('input.enablePlaceApi');
      };
    })(this));
  };

  DesktopSearch.prototype.lockSubmit = function(lock) {
    if (lock == null) {
      lock = false;
    }
    if (lock) {
      this.$submitBtn.attr('disabled', true).removeClass('icon-magnifying-glass').addClass('ls-loading-white');
      this.$location.eventPause('pause').addClass('search-hide-selection');
      this.$primaryNavTabs.eventPause('pause');
    } else {
      this.$submitBtn.attr('disabled', false).removeClass('ls-loading-white').addClass('icon-magnifying-glass');
      this.$location.eventPause('active');
      this.$primaryNavTabs.eventPause('active');
    }
  };

  DesktopSearch.prototype.selectAndTab = function($trigger, shiftKey) {
    var source;
    source = this.selectAndFillWithoutSubmit($trigger);
    this.$resultList.hide();
    if (source === 'location') {
      if (shiftKey) {
        this.$search.focus();
      } else {
        this.$submitBtn.focus();
      }
    } else {
      if (!shiftKey) {
        this.$location.focus();
      }
    }
  };

  return DesktopSearch;

})(SearchBarView);

